import axios from 'axios';
import config from '../config/environment-config';

const
	walletApiBaseURL = config[process.env.NODE_ENV][environment.region].API,
	balance = () => axios.get(`${walletApiBaseURL}/balance`, { withCredentials: true }),
	paymentMethods = () => axios.get(`${walletApiBaseURL}/methods`, { withCredentials: true }),
	paymentMethodsNX = (params = {}) => axios.get(`${walletApiBaseURL}/methods/pricepoint`, { params, withCredentials: true }),
	pricePoint = () => axios.get(`${walletApiBaseURL}/pricepoint`, { withCredentials: true }),
	history = (historyType, index = 1, type = 'all', count = 10) => {
		if (historyType === 'shop') {
			return axios.get(`${walletApiBaseURL}/history/shop`,
				{
					params: {
						index,
						count
					},
					withCredentials: true
				});
		} else if (historyType === 'coupon') {
			return axios.get(`${walletApiBaseURL}/history/coupon`,
				{
					params: {
						index,
						count
					},
					withCredentials: true
				});
		}
		return axios.get(`${walletApiBaseURL}/history`,
			{
				params: {
					index,
					count,
					type
				},
				withCredentials: true
			});
	},
	maxBalance = () => axios.get(`${walletApiBaseURL}/maxbalance`),
	checkoutToken = (params = {}) =>
		axios.get(`${walletApiBaseURL}/checkout-token`, { params, withCredentials: true }),
	WalletAPI = {
		install(Vue) {
			Vue.prototype.$walletAPI = {
				balance,
				paymentMethods,
				paymentMethodsNX,
				pricePoint,
				history,
				maxBalance,
				checkoutToken
			};
		}
	};

export default WalletAPI;
export { balance, paymentMethods, paymentMethodsNX, pricePoint, history };



// WEBPACK FOOTER //
// ./src/plugins/WalletAPI.js